<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                    <button @click="save()"
                            class="bg-green-500 text-sm hover:bg-green-700 text-white text-base font-bold my-0 -mt-10 py-3 px-6 rounded">
                        <i class="fas fa-save mx-1"></i>
                        Enviar
                    </button>
                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    <i class="fas fa-question-circle mr-1"></i> Ajuda e suporte
                </h2>
            </div>
        </template>
       
        <div class="pb-6">
            <div class="max-w-7xl mx-auto mt-10 py-10 sm:px-6 lg:px-8">
                <flash :timeout="5000"/>
                <template>
                    <jet-form-section>
                        <template #title>
                            Ajuda e Suporte
                        </template>

                        <template #description>
                            Você pode enviar uma pergunta sobre o sistema caso tenha dúvidas, você também pode reportar erros caso identifique algum e também fazer sugestões para melhoria do sistema.
                        </template>

                        <template #form>
                                <div class="md:col-span-6 sm:col-span-6">
                                    <jet-label for="subject" value="Assunto"/>
                                    <jet-input id="subject" type="text" class="mt-1 block w-full"
                                               v-model="form.subject"/>
                                    <jet-input-error :message="form.error('subject')" class="mt-2"/>
                                </div>

                                <div class="md:col-span-6 sm:col-span-6">
                                    <jet-label for="url_error" value="URL, seção ou página"/>
                                    <jet-input id="" type="text" class="mt-1 block w-full"
                                               v-model="form.url_error"/>
                                    <jet-input-error :message="form.error('url_error')" class="mt-2"/>
                                </div>

                                <div class="md:col-span-6 sm:col-span-6">
                                        <jet-label for="description" value="Descreva detalhadamente o problema, dúvida, sugestão ou solicitação"/>
                                        <textarea
                                            class="w-full block px-3 py-2 rounded-md border border-solid border-black text-gray-700 focus:outline-none"
                                            v-model="form.description"
                                            rows="4"></textarea>
                                        <jet-input-error :message="form.error('description')"/>
                                </div>

                                <div class="md:col-span-5 sm:col-span-5 ">
                                    <jet-label for="label_document_file" value="Print da tela, se necessário"/>
                                    <input type="file"
                                        name="file"
                                        id="file"
                                        ref="inputFile"
                                        @change="form.file = $event.target.files[0]"
                                    />
                                    <button class="rounded-md border border-solid border-gray-400 hover:border-gray-500 focus:border-gray-600 text-black bg-gray-200 hover:bg-gray-300 px-1" v-on:click="clearImage()">Remover anexo (X)</button>
                                    <jet-input-error :message="form.error('file')" class="mt-2"/>
                                    <jet-label for="label_document_file" value="Formatos aceitos jpg, jpeg, png, bmp, gif, svg e webp"/>
                                    
                                </div>
                                <div class="col-span-1 py-5">
                                        <button class="rounded-md border border-solid border-gray-400 hover:border-gray-500 focus:border-gray-600 text-black bg-gray-200 hover:bg-gray-300 px-1" v-on:click="clearAll()">Limpar</button>
                                </div>
                            
                        </template>
                    </jet-form-section>

                </template>
            </div>
        </div>
    </app-layout>
</template>
<script>
    import JetActionMessage from './../../Jetstream/ActionMessage'
    import JetButton from './../../Jetstream/Button'
    import JetFormSection from './../../Jetstream/FormSection'
    import JetInput from './../../Jetstream/Input'
    import JetInputError from './../../Jetstream/InputError'
    import JetLabel from './../../Jetstream/Label'
    import AppLayout from './../../Layouts/AppLayout'
    import JetActionSection from './../../Jetstream/ActionSection'
    import JetSectionBorder from './../../Jetstream/SectionBorder'
    import JetDangerButton from './../../Jetstream/DangerButton'
    import JetConfirmationModal from "./../../Jetstream/ConfirmationModal"
    import JetTextarea from "../../Jetstream/Textarea"
    import JetProtectedTextarea from "../../Jetstream/ProtectedTextarea"
    import JetAutoComplete from "../../Jetstream/AutoComplete"
    import JetSecondaryButton from "../../Jetstream/SecondaryButton"
    import JetMaskedInput from "../../Jetstream/MaskedInput"
    import JetFetchDoc from "../../Jetstream/FetchDoc"
    import Flash from "../../Helpers/Flash"
    import moment from 'moment/dist/moment'


export default {
    props: ['error'],
    data() {
        return {
            form: this.$inertia.form({
                _method: 'POST',
                subject: null,
                contact: this.$page.props.user.email,
                url_error: null,
                description: null,
                file: null,
            }),
        }
    },
    methods: {
        clearImage(){
            this.$refs.inputFile.value = null;
        },
        clearAll(){
            this.form.subject = null;
            this.form.url_error = null;
            this.form.description = null;
        },
        save: function(){
            let endpoint = `/report-error`;
            this.form.post(endpoint, {
                preserveScroll: true,
                onSuccess: () => {
                    this.form.processing = true
                    this.clearImage()
                },
                onError: () => {
                    this.form.processing = false
                }
            });
        },
    },
    components: {
        AppLayout,
        Flash,
        JetAutoComplete,
        JetSectionBorder,
        JetActionMessage,
        JetActionSection,
        JetDangerButton,
        JetConfirmationModal,
        JetButton,
        JetFormSection,
        JetInput,
        JetTextarea,
        JetProtectedTextarea,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        JetMaskedInput,
        JetFetchDoc,
    },
}
</script>
